import React, { Component } from 'react';
import { Modal, Radio } from 'antd';

const RadioGroup = Radio.Group;

class PayType extends Component {
    state = {
        type: '',
        prevType: '',
        visible: false,
        loading: false,
    }

    show = (type) => {
        this.setState({
            type,
            prevType: type,
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (e) => {
        this.setState({ type: e.target.value });
    }

    confirm = () => {
        const { type, prevType } = this.state;
        if (prevType !== type) {
            Modal.confirm({
                iconType: 'question-circle',
                title: '修改付款计划类型后，原付款计划表中已添加的数据将清空，是否确认修改？',
                onOk: () => {
                    this.props.changeType(type);
                    this.hide();
                }
            });
        } else {
            this.props.changeType(type);
            this.hide();
        }
    }

    render() {
        const { type, visible, loading } = this.state;
        const radioStyle = {
            display: 'block',
            margin: 10,
        };
        return (
            <Modal
                title="设置付款计划类型"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="500px"
                confirmLoading={loading}
            >
                <div style={{ padding: '0px 10px 10px' }}>
                    <div style={{ padding: 10, background: '#f1f1f1' }}>请选择付款类型</div>
                    <div className="item" style={{ width: '65%' }}>
                        <RadioGroup onChange={this.handleChange} value={type}>
                            <Radio value="serviceCycle" style={radioStyle}>按服务周期付款</Radio>
                            <Radio value="milestone" style={radioStyle}>按里程碑付款</Radio>
                        </RadioGroup>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default PayType;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Payment/Components/PayType.js